import React, { useState } from 'react';
import './packages.css';

function Packages() {
  const [activeTab, setActiveTab] = useState('withoutDriver');

  // Without driver packages data
  const withoutDriverPackages = [
    {
      category: "Alto / Kwid / Panda",
      packages: [
        { period: "1 day", price: "Rs.3,500/-", km: "100km", extra: "Rs.30/km" },
        { period: "1 week", price: "Rs.22,750/-", km: "700km", extra: "Rs.30/km" },
        { period: "2 weeks", price: "Rs.42,000/-", km: "1400km", extra: "Rs.25/km" },
        { period: "1 month", price: "Rs.80,000/-", km: "3000km", extra: "Rs.20/km" }
      ]
    },
    {
      category: "Eon / Elite",
      packages: [
        { period: "1 day", price: "Rs.4,000/-", km: "100km", extra: "Rs.35/km" },
        { period: "1 week", price: "Rs.26,250/-", km: "700km", extra: "Rs.35/km" },
        { period: "2 weeks", price: "Rs.49,000/-", km: "1400km", extra: "Rs.30/km" },
        { period: "1 month", price: "Rs.90,000/-", km: "3000km", extra: "Rs.25/km" }
      ]
    },
    {
      category: "Suzuki A-star / Mira",
      packages: [
        { period: "1 day", price: "Rs.4,500/-", km: "100km", extra: "Rs.40/km" },
        { period: "1 week", price: "Rs.28,000/-", km: "700km", extra: "Rs.35/km" },
        { period: "2 weeks", price: "Rs.52,500/-", km: "1400km", extra: "Rs.35/km" },
        { period: "1 month", price: "Rs.100,000/-", km: "3000km", extra: "Rs.30/km" }
      ]
    },
    {
      category: "WagonR 2014-16",
      packages: [
        { period: "1 day", price: "Rs.5,500/-", km: "100km", extra: "Rs.50/km" },
        { period: "1 week", price: "Rs.35,000/-", km: "700km", extra: "Rs.45/km" },
        { period: "2 weeks", price: "Rs.63,000/-", km: "1400km", extra: "Rs.40/km" },
        { period: "1 month", price: "Rs.140,000/-", km: "3000km", extra: "Rs.35/km" }
      ]
    },
    {
      category: "WagonR 2017-23 / Mitsubishi N Wagon / Hustlar / Spacia",
      packages: [
        { period: "1 day", price: "Rs.6,000/-", km: "100km", extra: "Rs.55/km" },
        { period: "1 week", price: "Rs.45,500/-", km: "700km", extra: "Rs.50/km" },
        { period: "2 weeks", price: "Rs.84,000/-", km: "1400km", extra: "Rs.45/km" },
        { period: "1 month", price: "Rs.160,000/-", km: "3000km", extra: "Rs.40/km" }
      ]
    },
    {
      category: "Toyota Aqua / Honda Fit",
      packages: [
        { period: "1 day", price: "Rs.7,000/-", km: "100km", extra: "Rs.65/km" },
        { period: "1 week", price: "Rs.45,500/-", km: "700km", extra: "Rs.60/km" },
        { period: "2 weeks", price: "Rs.84,000/-", km: "1400km", extra: "Rs.55/km" },
        { period: "1 month", price: "Rs.130,000/-", km: "3000km", extra: "Rs.50/km" }
      ]
    },
    {
      category: "Mini Van Seven Seater",
      packages: [
        { period: "1 day", price: "Rs.6,500/-", km: "100km", extra: "Rs.60/km" },
        { period: "1 week", price: "Rs.42,000/-", km: "700km", extra: "Rs.55/km" },
        { period: "2 weeks", price: "Rs.77,000/-", km: "1400km", extra: "Rs.50/km" },
        { period: "1 month", price: "Rs.145,000/-", km: "3000km", extra: "Rs.45/km" }
      ]
    },
    {
      category: "Prius / Axio",
      packages: [
        { period: "1 day", price: "Rs.9,000/-", km: "100km", extra: "Rs.75/km" },
        { period: "1 week", price: "Rs.59,500/-", km: "700km", extra: "Rs.70/km" },
        { period: "2 weeks", price: "Rs.108,500/-", km: "1400km", extra: "Rs.65/km" },
        { period: "1 month", price: "Rs.220,000/-", km: "3000km", extra: "Rs.60/km" }
      ]
    },
    {
      category: "Honda Vezel 2014-2018",
      packages: [
        { period: "1 day", price: "Rs.10,500/-", km: "100km", extra: "Rs.75/km" },
        { period: "1 week", price: "Rs.68,250/-", km: "700km", extra: "Rs.70/km" },
        { period: "2 weeks", price: "Rs.126,000/-", km: "1400km", extra: "Rs.65/km" },
        { period: "1 month", price: "Rs.255,000/-", km: "3000km", extra: "Rs.60/km" }
      ]
    },
    {
      category: "Toyota KDH",
      packages: [
        { period: "1 day", price: "Rs.15,000/-", km: "100km", extra: "Rs.95/km" },
        { period: "1 week", price: "Rs.91,000/-", km: "700km", extra: "Rs.90/km" },
        { period: "2 weeks", price: "Rs.161,000/-", km: "1400km", extra: "Rs.85/km" },
        { period: "1 month", price: "Rs.320,000/-", km: "3000km", extra: "Rs.75/km" }
      ]
    }
  ];


  return (
    <div className="packages">
      <h1>Vehicle Rental Packages</h1>
      
      <div className="tabs">
        <button 
          className={`tab-button ${activeTab === 'withoutDriver' ? 'active' : ''}`}
          onClick={() => setActiveTab('withoutDriver')}
        >
          Without Driver
        </button>
        <button 
          className={`tab-button ${activeTab === 'withDriver' ? 'active' : ''}`}
          onClick={() => setActiveTab('withDriver')}
        >
          With Driver
        </button>
      </div>



      
{activeTab === 'withoutDriver' && (
  <div className="without-driver-container">
    <h2>Self-Drive Vehicle Rentals</h2>
    <p className="section-description">Rent your preferred vehicle and enjoy the freedom of self-driving. All packages include comprehensive insurance and 24/7 roadside assistance.</p>
    
    <div className="packages-container">
      {withoutDriverPackages.map((category, index) => (
        <div key={index} className="vehicle-category">
          <h3 className="category-title">{category.category}</h3>
          <div className="packages-grid">
            {category.packages.map((pkg, pkgIndex) => (
              <div key={pkgIndex} className="package-card">
                <div className="package-header">
                  <h4 className="period">{pkg.period}</h4>
                  <div className="prc">{pkg.price}</div>
                </div>
                <div className="package-details">
                  <div className="detail-item">
                    <span className="detail-label">Distance Included:</span>
                    <span className="detail-value">{pkg.km}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Extra Kilometer:</span>
                    <span className="detail-value">{pkg.extra}</span>
                  </div>
                </div>
                <button className="book-now-btn">Book Now</button>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>

    <div className="rental-terms">
      <h3>Rental Terms & Conditions</h3>
      <div className="terms-grid">
        <div className="term-item">
          <div className="term-icon">🛡️</div>
          <div className="term-content">
            <h4>Insurance Included</h4>
            <p>Comprehensive insurance coverage for peace of mind</p>
          </div>
        </div>
        <div className="term-item">
          <div className="term-icon">🛣️</div>
          <div className="term-content">
            <h4>Free Delivery</h4>
            <p>Free vehicle delivery within city limits</p>
          </div>
        </div>
        <div className="term-item">
          <div className="term-icon">📋</div>
          <div className="term-content">
            <h4>Easy Documentation</h4>
            <p>Simple ID and license verification process</p>
          </div>
        </div>
        <div className="term-item">
          <div className="term-icon">🔧</div>
          <div className="term-content">
            <h4>24/7 Support</h4>
            <p>Round-the-clock roadside assistance</p>
          </div>
        </div>
      </div>
    </div>
  </div>
)}





     {activeTab === 'withDriver' && (
  <div className="with-driver-container">
    <h2>Vehicles with Driver</h2>
    
    {/* With Driver Packages */}
    <div className="driver-categories">
      {/* Small Cars Category */}
      <div className="driver-category">
        <h3 className="driver-category-title">Small Cars</h3>
        <div className="driver-table">
          <div className="table-header">
            {/* <div className="col-vehicle">Vehicle</div> */}
            <div className="col-drop">Drop (LKR)</div>
            <div className="col-up">Up & Down (LKR)</div>
          </div>
          <div className="table-row">
            <div className="col-vehicle">Alto</div>
            <div className="col-drop">110</div>
            <div className="col-up">80</div>
          </div>
          <div className="table-row">
            <div className="col-vehicle">Kwid</div>
            <div className="col-drop">110</div>
            <div className="col-up">80</div>
          </div>
          <div className="table-row">
            <div className="col-vehicle">Eon</div>
            <div className="col-drop">110</div>
            <div className="col-up">80</div>
          </div>
        </div>
      </div>

      {/* Compact Cars Category */}
      <div className="driver-category">
        <h3 className="driver-category-title">Compact Cars</h3>
        <div className="driver-table">
          <div className="table-header">
            {/* <div className="col-vehicle">Vehicle</div> */}
            <div className="col-drop">Drop (LKR)</div>
            <div className="col-up">Up & Down (LKR)</div>
          </div>
          <div className="table-row">
            <div className="col-vehicle">Wagon R</div>
            <div className="col-drop">120</div>
            <div className="col-up">90</div>
          </div>
          <div className="table-row">
            <div className="col-vehicle">Spacia</div>
            <div className="col-drop">120</div>
            <div className="col-up">90</div>
          </div>
          <div className="table-row">
            <div className="col-vehicle">N Wagon</div>
            <div className="col-drop">120</div>
            <div className="col-up">90</div>
          </div>
        </div>
      </div>

      {/* Premium Cars Category */}
      <div className="driver-category">
        <h3 className="driver-category-title">Premium Cars</h3>
        <div className="driver-table">
          <div className="table-header">
            {/* <div className="col-vehicle">Vehicle</div> */}
            <div className="col-drop">Drop (LKR)</div>
            <div className="col-up">Up & Down (LKR)</div>
          </div>
          <div className="table-row">
            <div className="col-vehicle">Aqua</div>
            <div className="col-drop">135</div>
            <div className="col-up">95</div>
          </div>
          <div className="table-row">
            <div className="col-vehicle">Prius</div>
            <div className="col-drop">135</div>
            <div className="col-up">95</div>
          </div>
          <div className="table-row">
            <div className="col-vehicle">Axio</div>
            <div className="col-drop">135</div>
            <div className="col-up">95</div>
          </div>
          <div className="table-row">
            <div className="col-vehicle">Vezel</div>
            <div className="col-drop">135</div>
            <div className="col-up">95</div>
          </div>
          <div className="table-row">
            <div className="col-vehicle">CHR</div>
            <div className="col-drop">135</div>
            <div className="col-up">95</div>
          </div>
          <div className="table-row">
            <div className="col-vehicle">Premio</div>
            <div className="col-drop">135</div>
            <div className="col-up">95</div>
          </div>
        </div>
      </div>

      {/* Vans - Non AC Category */}
      <div className="driver-category">
        <h3 className="driver-category-title">Vans - Non AC</h3>
        <div className="driver-table">
          <div className="table-header">
            {/* <div className="col-vehicle">Vehicle</div> */}
            <div className="col-drop">Drop (LKR)</div>
            <div className="col-up">Up & Down (LKR)</div>
          </div>
          <div className="table-row">
            <div className="col-vehicle">Caravan</div>
            <div className="col-drop">180</div>
            <div className="col-up">110</div>
          </div>
          <div className="table-row">
            <div className="col-vehicle">Dolphin</div>
            <div className="col-drop">180</div>
            <div className="col-up">110</div>
          </div>
        </div>
      </div>

      {/* Vans - With AC Category */}
      <div className="driver-category">
        <h3 className="driver-category-title">Vans - With AC</h3>
        <div className="driver-table">
          <div className="table-header">
            {/* <div className="col-vehicle">Vehicle</div> */}
            <div className="col-drop">Drop (LKR)</div>
            <div className="col-up">Up & Down (LKR)</div>
          </div>
          <div className="table-row">
            <div className="col-vehicle">Caravan</div>
            <div className="col-drop">190</div>
            <div className="col-up">120</div>
          </div>
          <div className="table-row">
            <div className="col-vehicle">Dolphin</div>
            <div className="col-drop">190</div>
            <div className="col-up">120</div>
          </div>
        </div>
      </div>

      {/* KDH Vans Category */}
      <div className="driver-category">
        <h3 className="driver-category-title">KDH Vans</h3>
        <div className="driver-table">
          <div className="table-header">
            {/* <div className="col-vehicle">Vehicle</div> */}
            <div className="col-drop">Drop (LKR)</div>
            <div className="col-up">Up & Down (LKR)</div>
          </div>
          <div className="table-row">
            <div className="col-vehicle">KDH Flatroof</div>
            <div className="col-drop">220</div>
            <div className="col-up">125</div>
          </div>
          <div className="table-row">
            <div className="col-vehicle">KDH Highroof</div>
            <div className="col-drop">240</div>
            <div className="col-up">145</div>
          </div>
        </div>
      </div>
    </div>





    <div className="note">
      <p><strong>Note:</strong> All rates are in Sri Lankan Rupees (LKR). Rates include driver service.</p>
      <p><strong>Drop:</strong> One-way service | <strong>Up & Down:</strong> Round trip service</p>
    </div>
  </div>
)}
    </div>
  );
}

export default Packages;